export default "__VITE_ASSET__AV_biV3g__"